import { Component, inject } from '@angular/core';
import { LienEvitementComponent } from '~shared/components/lien-evitement/lien-evitement.component';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { StringFieldComponent } from '~shared/components/form/fields/field/string-field/string-field.component';
import { LoaderComponent } from '~shared/components/loader/loader.component';
import { LoaderModule } from '~shared/components/loader/loader.module';
import { PasswordResetService } from '~shared/services/api/general/password-reset.service';

@Component({
  selector: 'app-reset-password',
  imports: [
    TranslateModule,
    StringFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    LoaderModule,
    LienEvitementComponent,
  ],
  providers: [LoaderComponent],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {
  private passwordResetService = inject(PasswordResetService);
  protected loader = inject(LoaderComponent);
  formGroup = new FormGroup({
    email: new FormControl('', [Validators.required]),
  });

  submitted = false;
  sent = false;

  constructor() {
    // `LoaderComponent` nait avec son etat a `true` — un choix assume, pour
    // que les `<app-loader>` poses sans entree s'affichent d'eux-memes. Mais
    // cette page l'injecte comme un SERVICE et garde son rendu par
    // `@if (loader.getLoading())`, alors qu'elle ne charge rien a l'arrivee :
    // aucun `ngOnInit` ne venait rabaisser le voile, qui tournait donc
    // indefiniment des l'ouverture de l'ecran.
    //
    // C'est le dernier recours de quelqu'un qui ne peut plus se connecter :
    // un voile perpetuel le laisse devant une page morte.
    this.loader.setLoading(false);
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroup.valid) {
      const email = this.formGroup.get('email')?.value;
      const formData = new FormData();
      formData.append('email', String(email));
      this.loader.setLoading(true);
      this.passwordResetService.passwordForget(formData).subscribe(
        () => {
          this.sent = true;
          this.loader.setLoading(false);
        },
        (error) => {
          this.loader.setLoading(false);
          // `form_errors` n'accompagne que les refus de validation. Sur toute
          // autre erreur -- panne serveur, coupure réseau --, il est absent, et
          // `Object.entries(undefined)` levait : la gestion d'erreur echouait
          // elle-même et l'utilisateur n'obtenait plus rien du tout sur l'écran
          // qui lui sert justement de dernier recours.
          const champsEnErreur = error?.error?.form_errors;
          if (champsEnErreur) {
            Object.entries(champsEnErreur).forEach(([key, value]) => {
              const control = this.formGroup.get(key);
              if (control) {
                control.setErrors({ email: value });
              }
            });
          }
          console.error('Error during password reset request', error);
        }
      );
    }
  }
}
